import { render, staticRenderFns } from "./ScreenInvoicingRequisition.vue?vue&type=template&id=24676fba&scoped=true"
import script from "./ScreenInvoicingRequisition.vue?vue&type=script&lang=js"
export * from "./ScreenInvoicingRequisition.vue?vue&type=script&lang=js"
import style0 from "./ScreenInvoicingRequisition.vue?vue&type=style&index=0&id=24676fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24676fba",
  null
  
)

export default component.exports